{
  "name": "@manasija/max",
  "version": "1.1.2",
  "description": "Max - AI agent for deep financial research.",
  "type": "module",
  "main": "dist/index.js",
  "bin": {
    "max": "dist/index.js",
    "max-gateway": "dist/gateway.js"
  },
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=18"
  },
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "start": "bun run src/index.tsx",
    "dev": "bun --watch run src/index.tsx",
    "gateway": "tsx src/gateway/index.ts run",
    "gateway:login": "tsx src/gateway/index.ts login",
    "build": "node scripts/build.mjs",
    "typecheck": "tsc --noEmit",
    "test": "bun test",
    "test:watch": "bun test --watch",
    "prepublishOnly": "npm run build",
    "postinstall": "playwright install chromium"
  },
  "dependencies": {
    "@langchain/anthropic": "^1.3.25",
    "@langchain/core": "^1.1.36",
    "@langchain/exa": "^1.0.1",
    "@langchain/google-genai": "^2.1.26",
    "@langchain/ollama": "^1.2.6",
    "@langchain/openai": "^1.3.1",
    "@langchain/tavily": "^1.2.0",
    "@mariozechner/pi-tui": "^0.52.12",
    "@modelcontextprotocol/sdk": "^1.29.0",
    "@mozilla/readability": "^0.6.0",
    "@whiskeysockets/baileys": "7.0.0-rc.9",
    "axios": "^1.17.0",
    "better-sqlite3": "^12.8.0",
    "croner": "^9.1.0",
    "diff": "^8.0.4",
    "dotenv": "^17.3.1",
    "exa-js": "^2.10.1",
    "gray-matter": "^4.0.3",
    "langsmith": "^0.4.12",
    "linkedom": "^0.18.12",
    "lru-cache": "^11.5.1",
    "playwright": "^1.58.2",
    "qrcode-terminal": "^0.12.0",
    "turndown": "^7.2.4",
    "zod": "^4.3.6"
  },
  "devDependencies": {
    "@babel/core": "^7.29.0",
    "@babel/preset-env": "^7.29.2",
    "@types/better-sqlite3": "^7.6.13",
    "@types/bun": "latest",
    "@types/jest": "^29.5.14",
    "@types/qrcode-terminal": "^0.12.2",
    "@types/turndown": "^5.0.6",
    "babel-jest": "^30.3.0",
    "esbuild": "^0.27.3",
    "jest": "^29.7.0",
    "ts-jest": "^29.4.6",
    "tsx": "^4.21.0",
    "typescript": "^5.9.3"
  }
}
